import { render, staticRenderFns } from "./TeamPersonSelect.vue?vue&type=template&id=5c095ede&scoped=true"
import script from "./TeamPersonSelect.vue?vue&type=script&lang=js"
export * from "./TeamPersonSelect.vue?vue&type=script&lang=js"
import style0 from "./TeamPersonSelect.vue?vue&type=style&index=0&id=5c095ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c095ede",
  null
  
)

export default component.exports